<template>
    <div>
        <Dialog
            :visible="displayConfirmation"
            :header="title"
            :style="{ width: '350px' }"
            :modal="true"
            :closable="false"
            :closeOnEscape="false"
        >
            <Spinner v-if="displaySpinner" />
            <div style="display: flex">
                <i
                    class="pi pi-exclamation-triangle mr-3"
                    style="font-size: 2rem; margin-right: 1rem"
                />
                <span>{{ message }}</span>
            </div>
            <template #footer>
                <Button
                    :label="closeLabel"
                    :autofocus="autofocus === 'close'"
                    class="p-button-secondary"
                    @click="closeConfirmation"
                />
                <Button
                    severity="danger"
                    :label="confirmLabel"
                    :autofocus="autofocus === 'confirm'"
                    class="p-button-secondary"
                    @click="successConfirmation"
                />
            </template>
        </Dialog>
    </div>
</template>

<script setup lang="ts">
import { watch } from "vue";
import { useMagicKeys } from "@vueuse/core";
import Spinner from "@/shared/Spinner.vue";

const props = defineProps({
    displayConfirmation: {
        type: Boolean,
        default: false,
    },
    displaySpinner: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: "Confirmation",
    },
    message: {
        type: String,
    },
    closeLabel: {
        type: String,
        default: "No",
    },
    confirmLabel: {
        type: String,
        default: "Yes",
    },
    autofocus: {
        type: String,
        default: "",
    },
});

const emit = defineEmits(["close-confirmation", "success-confirm"]);
const keys = useMagicKeys();

const closeConfirmation = () => emit("close-confirmation");
const successConfirmation = () => emit("success-confirm");

/**
 * Listen to the escape only after a set delay.
 */
const closeOnEscapeListener = () => {
    const DELAY_MS = 500;
    let whenVisible: Date = new Date();

    watch(
        () => props.displayConfirmation,
        (newValue, oldVaue) => {
            if (newValue && !oldVaue) {
                whenVisible = new Date();
            }
        }
    );

    watch(keys.escape, (newValue) => {
        if (
            newValue &&
            new Date().getTime() - whenVisible.getTime() > DELAY_MS
        ) {
            closeConfirmation();
        }
    });
};

closeOnEscapeListener();
</script>
